import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from '../../core/components/card/component/card.component';
import { ThemeService } from '../../core/services/theme/theme.service';
import { CardService } from '../../core/services/card/card.service';
import { CardModel } from '../../core/components/card/models/card.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent {
  title = 'Générez vos modèles MCD, MLD et diagrammes de séquence.';

  description = `DevModeler est un outil pour les devs, conçu par des devs, qui vous permet de réaliser à la fois vos diagrammes de séquence 
  et la modélisation de vos bases de données. Cette plateforme vous permet de structurer vos idées dès les premières étapes du développement. 
  Que vous soyez un développeur débutant ou expérimenté, DevModeler vous accompagne dans la création, l’organisation et la visualisation de vos projets de manière
intuitive et efficace. Démarrez rapidement, itérez facilement, et gérez l'ensemble de vos modèles de données et de flux de travail à un seul
endroit.`;

  private _themeService = inject(ThemeService);

  private _cardService = inject(CardService);
  cards: CardModel[] = this._cardService.getCards();

  get isDarkMode(): Observable<boolean> {
    return this._themeService.isDarkMode();
  }
}
